

























import { defineComponent, ref } from '@vue/composition-api';

const name = 'ttam-high-setting';
export default defineComponent({
  name,
  setup() {
    const isOpen = ref(false);
    const toggle = () => {
      isOpen.value = !isOpen.value;
    };
    return {
      name,
      isOpen,
      toggle,
    };
  },
});
